<template>
  <div class="filter-res mobile-d-none">
    <div v-if="setupsCount > 1">
      {{ setupsCount }} allestimenti disponibili
    </div>
    <div v-else>{{ setupsCount }} allestimento disponibile</div>
    <div class="filter-dropdown" @click="toggleDropdown">
      <span class="filter-title">
        Filtra per data
        <img
          src="../../../images/project-img/Arrow-Small-down.png"
          width="10"
          alt="arrow"
          class="caret-down"
          :class="{ rotated: isOpen }"
        />
      </span>
      <div class="dropdown" :class="{ 'd-none': !isOpen }" @click.stop>
        <ul>
          <li @click="selectFilter(null)">Tutte le date</li>
          <li v-for="(filter, index) in filters" :key="index" @click="selectFilter(filter)">
            {{ filter }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateFilter',
  props: {
    filters: {
      type: Array,
      required: true,
    },
    setupsCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectFilter(filter) {
      this.isOpen = false;
      this.$emit('filter-changed', filter);
      console.log('Selected filter:', filter);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/DateFilter.vue